// extracted by mini-css-extract-plugin
module.exports = {"menuIcon":"BurgerIcon_menuIcon__1gJnS","open":"BurgerIcon_open__1z0xT","desktop":"BurgerIcon_desktop__3Yc-z"};